<template>
  <v-form ref="sendSmsForm">
    <v-row>
      <v-col cols="12">
        <v-textarea
            class="pt-0"
            v-model="message"
            placeholder="Treść wiadomości"
            :rules="rules.message"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn
            color="primary"
            block
            @click="send"
            :disabled="!userId"
        >
          Wyślij
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import api from "@/services/api";

export default {
  props: {
    // Id of the user.
    userId: [Number, String],
    clearOnSend: {
      type: [Boolean, String],
      required: false,
      default: true,
    },
  },
  data() {
    return {
      message: null,
      rules: {
        message: [
          (value) => !!value || 'Wpisz treść wiadomości.',
        ],
      },
    };
  },
  created() {
    this.$props.clearOnSend = (false !== this.$props.clearOnSend && '1' !== this.$props.clearOnSend);
  },
  methods: {
    clearIfRequested() {
      if (this.$props.clearOnSend) {
        this.clear();
      }
    },
    clear() {
      this.message = null;
    },
    send() {
      if (!this.$refs.sendSmsForm.validate()) {
        return;
      }

      let url, data = {};

      url = '/api/sms/send';
      data.userId = this.userId || null;
      data.message = String(this.message).trim();

      api.post(url, data)
          .then((response) => {
            if (202 === response.status) {
              if (true === response.data.report.sent) {
                this.$root.$emit('notifySuccess', {
                  html: 'Serwer potwierdził przyjęcie wiadomości do wysłania.',
                });
              } else {
                this.$root.$emit('notifyWarning', {
                  html: 'Serwer potwierdził przyjęcie wiadomości, ale nie przekazał jej do wysłania. ' +
                  'Przyczyn może być wiele - odbiorca nie ma numeru, numer jest nieprawidłowy, numer nie jest ' +
                  'polskim numerem, wysyłka SMS-ów działa na tym serwerze w trybie testowym itp.',
                });
              }

              this.clearIfRequested();

              return;
            }

            this.$root.$emit('notifyError', {
              html:
                  `Serwer zwrócił inny kod odpowiedzi (${response.status}) HTTP niż oczekiwany (202). ` +
                  'Wiadomość mogła nie zostać wysłana.',
            });
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wysłać wiadomości.',
              error,
            });
          });
    },
  }
};
</script>